import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import T from '../theme';

// Telefon maskasi: +998 (XX) XXX-XX-XX
const formatPhone = (value) => {
  const digits = value.replace(/\D/g, '');
  // +998 ni olib tashlaymiz agar bor bo'lsa
  let num = digits;
  if (num.startsWith('998')) num = num.slice(3);
  if (num.length === 0) return '+998 ';
  if (num.length <= 2) return `+998 (${num}`;
  if (num.length <= 5) return `+998 (${num.slice(0, 2)}) ${num.slice(2)}`;
  if (num.length <= 7) return `+998 (${num.slice(0, 2)}) ${num.slice(2, 5)}-${num.slice(5)}`;
  return `+998 (${num.slice(0, 2)}) ${num.slice(2, 5)}-${num.slice(5, 7)}-${num.slice(7, 9)}`;
};

const cleanPhone = (formatted) => {
  const digits = formatted.replace(/\D/g, '');
  if (digits.startsWith('998')) return '+' + digits;
  return '+998' + digits;
};

// Ko'z ikonkasi
const EyeIcon = ({ open }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {open ? (
      <>
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
      </>
    ) : (
      <>
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
        <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
      </>
    )}
  </svg>
);

export default function LoginPage() {
  const [mode, setMode] = useState('login');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('+998 ');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [showPass2, setShowPass2] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handlePhoneChange = (e) => {
    const raw = e.target.value;
    // +998 ni o'chirishga ruxsat berma
    if (raw.replace(/\D/g, '').length < 3) {
      setPhone('+998 ');
      return;
    }
    const formatted = formatPhone(raw);
    // Max 9 ta raqam (+998 dan keyin)
    const afterCode = formatted.replace(/\D/g, '').slice(3);
    if (afterCode.length <= 9) {
      setPhone(formatted);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (mode === 'register') {
      if (password !== password2) {
        setError('Parollar mos kelmaydi');
        return;
      }
      if (password.length < 6) {
        setError('Parol kamida 6 ta belgidan iborat bo\'lishi kerak');
        return;
      }
    }

    setLoading(true);
    try {
      if (mode === 'login') {
        await login(username, password);
      } else {
        await register({
          username,
          password,
          first_name: firstName,
          last_name: lastName,
          phone: cleanPhone(phone),
        });
      }
      navigate('/');
    } catch (err) {
      const data = err.response?.data;
      if (typeof data === 'object') {
        setError(Object.values(data).flat().join(', '));
      } else {
        setError(mode === 'login' ? "Login yoki parol noto'g'ri" : 'Xatolik yuz berdi');
      }
    }
    setLoading(false);
  };

  const inp = {
    width: '100%', padding: '14px 18px',
    background: T.bg, border: `2px solid ${T.border}`,
    borderRadius: 14, fontSize: 15, fontFamily: T.font,
    fontWeight: 600, color: T.text, outline: 'none',
    boxSizing: 'border-box', transition: 'all 0.2s',
  };

  const passWrap = {
    position: 'relative', width: '100%',
  };

  const eyeBtn = {
    position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)',
    background: 'none', border: 'none', cursor: 'pointer', padding: 4,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: `linear-gradient(135deg, ${T.bgDark} 0%, #0F2918 100%)`,
      fontFamily: T.font, padding: 20,
    }}>
      <div style={{
        background: '#fff', borderRadius: 28, padding: '40px 36px',
        width: '100%', maxWidth: 520, boxShadow: '0 25px 80px rgba(0,0,0,0.3)',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 72, height: 72, borderRadius: 20,
            background: `linear-gradient(135deg, ${T.blue}, ${T.blueLight})`,
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 34, marginBottom: 16,
            boxShadow: `0 12px 32px ${T.blue}50`,
          }}>🛡</div>
          <h1 style={{ fontSize: 28, fontWeight: 900, color: T.text, margin: '0 0 4px' }}>SafeChild</h1>
          <p style={{ fontSize: 14, color: T.textMuted, fontWeight: 600, margin: 0 }}>
            {mode === 'login' ? 'Tizimga kirish' : "Ro'yxatdan o'tish"}
          </p>
        </div>

        {/* Tab switcher */}
        <div style={{
          display: 'flex', gap: 4, marginBottom: 24,
          background: T.bg, padding: 4, borderRadius: 14,
        }}>
          {[
            { key: 'login', label: '🔐 Kirish' },
            { key: 'register', label: '📝 Ro\'yxatdan o\'tish' },
          ].map(t => (
            <button key={t.key} onClick={() => { setMode(t.key); setError(''); }} style={{
              flex: 1, padding: '12px 16px', borderRadius: 10,
              background: mode === t.key ? '#fff' : 'transparent',
              border: mode === t.key ? `1px solid ${T.border}` : 'none',
              boxShadow: mode === t.key ? T.shadow : 'none',
              fontSize: 14, fontWeight: 700, cursor: 'pointer',
              color: mode === t.key ? T.text : T.textMuted, fontFamily: T.font,
            }}>{t.label}</button>
          ))}
        </div>

        {/* Error */}
        {error && (
          <div style={{
            background: T.coralSoft, color: '#DC2626', padding: '12px 16px',
            borderRadius: 12, fontSize: 14, fontWeight: 700, marginBottom: 20,
            border: '1px solid #FCA5A5',
          }}>⚠️ {error}</div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit}>
          {mode === 'register' && (
            <>
              <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 12, fontWeight: 700, color: T.textSec, display: 'block', marginBottom: 6 }}>ISM</label>
                  <input
                    style={inp}
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                    placeholder="Ism"
                    required
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 12, fontWeight: 700, color: T.textSec, display: 'block', marginBottom: 6 }}>FAMILIYA</label>
                  <input
                    style={inp}
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                    placeholder="Familiya"
                  />
                </div>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 12, fontWeight: 700, color: T.textSec, display: 'block', marginBottom: 6 }}>TELEFON</label>
                <input
                  style={{ ...inp, fontFamily: T.mono, fontSize: 16, letterSpacing: 1 }}
                  type="tel"
                  value={phone}
                  onChange={handlePhoneChange}
                  placeholder="+998 (XX) XXX-XX-XX"
                />
              </div>
            </>
          )}

          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: T.textSec, display: 'block', marginBottom: 6 }}>LOGIN</label>
            <input
              style={inp}
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Login kiriting"
              autoComplete="username"
              required
            />
          </div>

          <div style={{ marginBottom: mode === 'register' ? 16 : 24 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: T.textSec, display: 'block', marginBottom: 6 }}>PAROL</label>
            <div style={passWrap}>
              <input
                style={{ ...inp, paddingRight: 48 }}
                type={showPass ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
                required
              />
              <button type="button" onClick={() => setShowPass(!showPass)} style={eyeBtn} tabIndex={-1}>
                <EyeIcon open={showPass} />
              </button>
            </div>
          </div>

          {mode === 'register' && (
            <div style={{ marginBottom: 24 }}>
              <label style={{ fontSize: 12, fontWeight: 700, color: T.textSec, display: 'block', marginBottom: 6 }}>PAROLNI TASDIQLASH</label>
              <div style={passWrap}>
                <input
                  style={{
                    ...inp,
                    paddingRight: 48,
                    borderColor: password2 && password2 !== password ? '#EF4444' : password2 && password2 === password ? T.blue : T.border,
                  }}
                  type={showPass2 ? 'text' : 'password'}
                  value={password2}
                  onChange={e => setPassword2(e.target.value)}
                  placeholder="Parolni qayta kiriting"
                  autoComplete="new-password"
                  required
                />
                <button type="button" onClick={() => setShowPass2(!showPass2)} style={eyeBtn} tabIndex={-1}>
                  <EyeIcon open={showPass2} />
                </button>
              </div>
              {password2 && password2 !== password && (
                <div style={{ fontSize: 12, color: '#EF4444', fontWeight: 700, marginTop: 6 }}>
                  ⚠ Parollar mos kelmaydi
                </div>
              )}
              {password2 && password2 === password && (
                <div style={{ fontSize: 12, color: T.blue, fontWeight: 700, marginTop: 6 }}>
                  ✓ Parollar mos
                </div>
              )}
            </div>
          )}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '16px',
            background: loading ? '#E5E7EB' : `linear-gradient(135deg, ${T.blue}, ${T.blueLight})`,
            color: loading ? '#9CA3AF' : '#fff', border: 'none',
            borderRadius: 14, fontSize: 17, fontWeight: 800,
            cursor: loading ? 'default' : 'pointer', fontFamily: T.font,
            boxShadow: loading ? 'none' : `0 8px 24px ${T.blue}40`,
          }}>
            {loading ? 'Kutib turing...' : (mode === 'login' ? '🔓 Kirish' : '✓ Ro\'yxatdan o\'tish')}
          </button>
        </form>

      </div>
    </div>
  );
}
